import type { IconProps } from "./icon-types";

/**
 * 복사(copy). 클립보드 복사/복제 진입점에서 사용.
 *
 * Heroicons v2의 `HiOutlineSquare2Stack`(square-2-stack) path를 인라인으로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 24 그리드 / stroke 기반. path(모양)는 원본 그대로 두되, 선굵기는 다른 c6 stroke
 * 글리프와 통일하기 위해 원본 1.5 → 2 로 맞춘다(round cap·join 유지).
 */
export const CopyIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6" />
  </svg>
);
